import { get } from "node:http";
import { axiosBase, errorHandler } from "./axios";

const getServiceList = () => {
    return axiosBase
        .get("api/v1/common/services")
        .then((res) => res.data)
        .catch((err) => errorHandler(err));
};

const getSpecializationsList = () => {
    return axiosBase
        .get("api/v1/common/specializations")
        .then((res) => res.data)
        .catch((err) => errorHandler(err));
};

const getDocumentTypesList = () => {
    return axiosBase
        .get("api/v1/common/documentTypes")
        .then((res) => res.data)
        .catch((err) => errorHandler(err));
};

const uploadFile = (data: {
    file: File;
    type: string;
    studioId?: string;
    userId: string;
    fileType: string;
}) => {
    const formData = new FormData();
    formData.append("file", data.file);
    formData.append("fileType", data.fileType);
    formData.append("type", data.type);
    formData.append("userId", data.userId);
    if (data.studioId) {
        formData.append("studioId", data.studioId);
    }

    return axiosBase
        .post("api/v1/common/uploadFile", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .then((res) => res.data)
        .catch((err) => errorHandler(err));
};

const removeFile = (data: { ids: string[]; portfolioId?: string }) => {
    return axiosBase
        .post("api/v1/common/removeFile", data)
        .then((res) => res.data)
        .catch((err) => errorHandler(err));
};

const getRole = (tenantId: string) => {
    return axiosBase
        .get("api/v1/common/get-role/" + tenantId)
        .then((res) => res.data)
        .catch((err) => errorHandler(err));
};

const getStudioList = (data: { tenantId: String; isActive: boolean }) => {
    return axiosBase
        .post("api/v1/common/get-studio/", data)
        .then((res) => res.data)
        .catch((err) => errorHandler(err));
};

const getAlbumTemplatesList = () => {
    return axiosBase
        .get("api/v1/common/album-templates")
        .then((res) => res.data)
        .catch((err) => errorHandler(err));
};

const getNotificationCount = () => {
    return axiosBase
        .get("/api/v1/notification/getCount")
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const listNotifications = (params: any = {}) => {
    const { page = 1, limit = 20 } = params;
    return axiosBase
        .get(`/api/v1/notification/list?page=${page}&limit=${limit}`)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const markAllRead = () => {
    return axiosBase
        .patch("/api/v1/notification/markAllRead")
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const markOneRead = (id: string) => {
    return axiosBase
        .patch(`/api/v1/notification/${id}/markRead`)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const fetchNotificationSettings = () => {
    return axiosBase
        .get(`/api/v1/notification/settings`)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const updateNotificationSettings = (services: Record<string, string[]>) => {
    return axiosBase
        .put(`/api/v1/notification/settingsUpdate`, { services })
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};
const viewNotification = (id: string) => {
    return axiosBase
        .get(`/api/v1/notification/view/${id}`)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const contactUs = (data: any) => {
    return axiosBase
        .post("/api/v1/common/contact-us", data)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const getRoutes = () => {
    return axiosBase
        .get("api/v1/common/routes")
        .then((res) => res.data)
        .catch((err) => errorHandler(err));
};

const getAccessibleRoutes = (id?: string) => {
    return axiosBase
        .get(`api/v1/common/accessible-routes`)
        .then((res) => res.data)
        .catch((err) => errorHandler(err));
};

const checkKycName = (userId: string) => {
    return axiosBase
        .post(`/api/v1/account/kyc-document-nameCheck`, { id: userId })
        .then((res) => res.data)
        .catch((err) => errorHandler(err));
};

const generateSessionSas = () => {
    return axiosBase
        .get(`/api/v1/common/azure/session-sas`)
        .then((res) => res.data)
        .catch((err) => errorHandler(err));
};

export const commonService = {
    getServiceList,
    getSpecializationsList,
    getDocumentTypesList,
    uploadFile,
    removeFile,
    getRole,
    getStudioList,
    getAlbumTemplatesList,
    getNotificationCount,
    listNotifications,
    markAllRead,
    markOneRead,
    fetchNotificationSettings,
    updateNotificationSettings,
    contactUs,
    getRoutes,
    getAccessibleRoutes,
    viewNotification,
    checkKycName,
    generateSessionSas
};
